import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DismissableBaseService } from "../../../../../lib/dismissable-base/dismissable-base.service";
import { UserMessageData } from "../models/user-message.model";
import { UserMessageFacade } from "./user-message.facade";

/**
 * Bridge between the legacy DismissableBaseService<T> contract and the new UserMessageFacade.
 * Consumed by portal components that share base classes with non-message services
 * (ReferralCodeBaseComponent, InsuranceQuoteBaseComponent) and cannot migrate
 * to UserMessageFacade directly without also refactoring the reminder use-cases.
 *
 * @see UserMessageFacade for the primary domain API.
 */
@Injectable({
	providedIn: "root",
})
export class UserMessageBridgeService extends DismissableBaseService<UserMessageData> {
	constructor(private readonly facade: UserMessageFacade) { super(); }

	query(entityId: number): Observable<UserMessageData[]> {
		return this.facade.getOnScreenMessages([entityId]);
	}

	update(
		customerId: number,
		entityId: number,
		message: UserMessageData,
		dismiss: boolean
	): Observable<void> {
		if (dismiss) {
			return this.facade.dismissMessage(message);
		}
		return this.facade.undismissMessage(message);
	}
}
